import React, { useEffect } from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { PageHero } from '../../components/PageHero';
import { FileText, Calendar, Download } from 'lucide-react';
import { motion } from 'framer-motion';
const decisions = [{
  title: 'Протокол засідання президії №12',
  date: '15 лютого 2026',
  description: 'Затвердження календаря змагань на 2026 рік та розподіл бюджету.'
}, {
  title: 'Протокол засідання президії №11',
  date: '20 грудня 2025',
  description: 'Підсумки діяльності федерації за 2025 рік. Звіт ревізійної комісії.'
}, {
  title: 'Протокол засідання президії №10',
  date: '18 жовтня 2025',
  description: 'Затвердження складу збірної команди на міжнародні змагання.'
}, {
  title: 'Протокол засідання президії №9',
  date: '25 серпня 2025',
  description: 'Розгляд заявок на присвоєння спортивних розрядів та звань.'
}, {
  title: 'Протокол засідання президії №8',
  date: '10 червня 2025',
  description: 'Внесення змін до положення про членство. Затвердження нових підрозділів.'
}, {
  title: 'Протокол засідання президії №7',
  date: '15 квітня 2025',
  description: 'Організація літніх навчальних зборів та школи інструкторів.'
}];
export function Decisions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-gray-50" data-id="element-719">
      <Header data-id="element-720" />
      <main className="pt-20" data-id="element-721">
        <PageHero label="Федерація" title="Рішення президії" subtitle="Протоколи засідань та рішення президії ФАіСУ" data-id="element-722" />

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-20" data-id="element-723">
          <div className="space-y-4" data-id="element-724">
            {decisions.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.06,
            duration: 0.4
          }} className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 flex items-start gap-4 group cursor-pointer" data-id="element-725">
                <div className="p-2.5 bg-primary/5 rounded-lg border border-primary/10 flex-shrink-0" data-id="element-726">
                  <FileText className="h-5 w-5 text-primary" data-id="element-727" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-728">
                  <h3 className="text-sm font-bold text-primary group-hover:text-primary-light transition-colors" data-id="element-729">
                    {item.title}
                  </h3>
                  <p className="text-gray-500 text-sm mt-1 leading-relaxed" data-id="element-730">
                    {item.description}
                  </p>
                  <div className="flex items-center gap-1.5 mt-2 text-gray-400 text-xs" data-id="element-731">
                    <Calendar className="h-3 w-3" data-id="element-732" />
                    {item.date}
                  </div>
                </div>
                <button className="flex-shrink-0 p-2 text-gray-300 hover:text-primary transition-colors" title="Завантажити" data-id="element-733">
                  <Download className="h-4 w-4" data-id="element-734" />
                </button>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-735" />
    </div>;
}